/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const MobileClubPageStyle = ({ palette }) => ({
    clubsType: {
        clear: 'both',
    },
    main: {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
    },
    textHeadingCenter: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    },
    headerSingleImage: {
        width: '100%',
        display: 'flex',
        backgroundRepeat: 'no-repeat',
    },
    heading: {
        width: '50%',
        textAlign: 'center',
    },
    clubHeading: {
        fontSize: '1em',
        color: palette.contentColor,
        fontWeight: '600',
        padding: '10px 10px',
        margin: 0,
    },
    typeData: {
        flexBasis: 'auto',
        float: 'left',
        padding: '10px',
        background: palette.white,
        overflow: 'hidden',
        width: '49%',
        boxSizing: 'border-box',
    },
    priceText: {
        minHeight: 40,
        fontSize: '0.9em',
        maxHeight: 40,
        overflow: 'hidden',
        margin: 0,
        fontWeight: 600,
    },
    content: {
        textAlign: 'center',
        width: '100%',
    },
    imageMainContainer: {
        width: '100%',
        '& img': {
            width: '100%',
        },
    },
    disclaimer: {
        backgroundColor: palette.cms?.clubsTypebackground || palette.clubsTypebackground,
        padding: '0px 20px 0px 20px',
    },
    disclaimerHeading: {
        fontSize: '18px',
        fontFamily: 'arial',
        fontWeight: '600',
    },
    disclaimerContent: {
        fontSize: '16px',
        fontFamily: 'arial',
    },
    sliderContainer: {
        marginBottom: 10,
        position: 'relative',
        '& .slick-list': {
            overflow: 'hidden',
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'top',
            maxWidth: '50%',
        },
        '& .slick-prev, & .slick-next': {
            transform: 'translate(0,-50%)',
            cursor: 'pointer',
            color: 'transparent',
            border: 'none',
            outline: 0,
            background: '0 0',
            fontSize: 0,
            lineHeight: 0,
            top: '50%',
            zIndex: 9999,
            width: 50,
            height: 50,
            position: 'absolute',
        },
    },
    featuredBackground: {
        background: palette.cms?.featuredWineBackground || '#595959',
    },
    featuredTextColor: {
        color: palette.white || '#fff',
    },
    productLabel: ({ titleFontFamily }) => ({
        minHeight: 40,
        fontSize: '0.9em',
        maxHeight: 40,
        overflow: 'hidden',
        fontFamily: titleFontFamily,
        textOverflow: 'ellipsis',
        margin: '5px 0',
        textDecoration: 'underline',
    }),
    passportEligibleImage: {
        maxHeight: '35px',
        maxWidth: '100%',
    },
    linkContainer: {
        color: 'inherit',
    },
});

export default MobileClubPageStyle;
